import { createFileRoute } from "@tanstack/react-router";
import { DadosVendasPage } from "@/paginas/analises-dados-vendas";

export const Route = createFileRoute("/_authenticated/dados-vendas")({
  head: () => ({
    meta: [
      { title: "Dados de vendas importados — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Registros diários de vendas importados, com totalização por dia, busca, impressão e exportação em PDF.",
      },
      { property: "og:title", content: "Dados de vendas importados — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Registros diários de vendas importados do controle de estoque da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: DadosVendasPage,
});
